import { type FC, memo, useCallback, useMemo } from "react";
import { ChipKind, LegacySelectChip } from "@stubhub/broadway-web";
import { FilterIcon } from "@stubhub/broadway-web/icons/functional";
import { HomeAwayOptions, type PriceBuckets } from "src/shared/enums/enums";
import { FiltersDrawer } from "src/website-apps/shared/components/immersive-performer/eventlist-filters/filters-drawer";
import type { PriceFilterState } from "src/website-apps/shared/hooks/useGridsReducer";

interface Props {
  isDrawerOpen: boolean;
  onToggleDrawer: () => void;
  homeAwayValue: Maybe<number>;
  onHomeAwayChange: (val: (typeof HomeAwayOptions)[keyof typeof HomeAwayOptions]) => void;
  priceValue: PriceFilterState;
  onPriceChange: (value: PriceBuckets[]) => void;
  disabled?: boolean;
}

export const MobileCalendarFilterIcon: FC<Props> = memo(
  ({ isDrawerOpen, onToggleDrawer, homeAwayValue, onHomeAwayChange, priceValue, onPriceChange, disabled = false }) => {
    const hasActiveFilters = useMemo(() => {
      const hasGameTypeFilter = homeAwayValue !== undefined && homeAwayValue !== 0;
      const hasPriceFilter = priceValue.length > 0;
      return hasGameTypeFilter || hasPriceFilter;
    }, [homeAwayValue, priceValue]);

    const onClearDrawer = useCallback(() => {
      onHomeAwayChange(HomeAwayOptions.BOTH);
      onPriceChange([]);
    }, [onHomeAwayChange, onPriceChange]);

    return (
      <>
        <LegacySelectChip
          icon={FilterIcon}
          onClick={onToggleDrawer}
          disabled={disabled}
          kind={ChipKind.Neutral}
          aria-label={hasActiveFilters ? "Filters (active filters applied)" : "Open filters"}
          isOpen={isDrawerOpen}
          showBadge={hasActiveFilters}
        />
        <FiltersDrawer
          kind="neutral"
          isOpen={isDrawerOpen}
          onClose={onToggleDrawer}
          onClear={onClearDrawer}
          homeAwayValue={homeAwayValue}
          onHomeAwayChange={onHomeAwayChange}
          showGameType
          priceValue={priceValue}
          onPriceChange={onPriceChange}
          showPrice
        />
      </>
    );
  },
);
MobileCalendarFilterIcon.displayName = "MobileCalendarFilterIcon";
